import { render, staticRenderFns } from "./Pois.vue?vue&type=template&id=a66fa206&scoped=true"
import script from "./Pois.vue?vue&type=script&lang=js"
export * from "./Pois.vue?vue&type=script&lang=js"
import style0 from "./Pois.vue?vue&type=style&index=0&id=a66fa206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66fa206",
  null
  
)

export default component.exports